import React, { useCallback } from "react";
import { TouchableOpacity } from "react-native";

import { Block, Typography } from "@stepapp/ui";

import { match } from "@stepapp/core";
import {
  hourItemContainerStyle,
  hourItemTypographyTypeMapping,
  hourItemTypographyVariantMapping,
} from "./styles";

export type HourItemTypes = "available" | "possible" | "selected" | "unavailable";

type Props = {
  hour: string;
  selectHour: (hour: string) => void;
  isDatePicked?: boolean;
  isAvailable?: boolean;
  selectedHour?: string;
};

const HourItem = ({
  hour,
  selectHour,
  isDatePicked = false,
  isAvailable = false,
  selectedHour = "",
}: Props) => {
  const handlePress = useCallback(() => selectHour(hour), [hour, selectHour]);

  const isSelectedHour = selectedHour === hour;

  const type = match({ isDatePicked, isSelectedHour, isAvailable })
    .with({ isDatePicked: true, isSelectedHour: true }, () => "selected")
    .with({ isDatePicked: true, isAvailable: true }, () => "available")
    .with({ isDatePicked: true, isAvailable: false }, () => "unavailable")
    .otherwise(() => "possible") as HourItemTypes;

  return (
    <TouchableOpacity disabled={!["available", "selected"].includes(type)} onPress={handlePress}>
      <Block
        justifyCenter
        alignCenter
        marginHorizontal={0.5}
        borderRadius={1}
        height={5}
        style={[hourItemContainerStyle[type]]}
      >
        <Typography
          decoration={type === "unavailable" ? "lineThrough" : "none"}
          type={hourItemTypographyTypeMapping[type]}
          variant={hourItemTypographyVariantMapping[type]}
        >
          {hour}
        </Typography>
      </Block>
    </TouchableOpacity>
  );
};

export default React.memo(HourItem);
